import { Map } from 'immutable';
import {
    UPDATE_SUBMITNOTICE_DETAILS,
    UPDATE_IS_NAME_ERROR,
    UPDATE_IS_QTY_ERROR,
    UPDATE_IS_AGE_ERROR,
    UPDATE_IS_DESCRIPTION_ERROR,
    UPDATE_IS_ITEMTYPE_ERROR,
    UPDATE_IS_ACTION_ERROR,
    UPDATE_IS_DETAILS_ERROR,
    UPDATE_ITEM_CONDITION_ERROR,
    UPDATE_IS_VALUE_ERROR,
    UPDATE_COUNT,
    UPDATE_NOTICE_ITEM_LIST,
    UPDATE_SUBMITNOTICESTEP2_VIEWMODEL,
    UPDATE_IS_AMOUNTSOUGHT_ERROR,
    UPDATE_IS_SEEK_COMPENSATION,
    UPDATE_NOTICENUMBER
} from '../actions/submitNotice';

const initialState = Map({
    submitNoticeDetails:[],
    isNameError: [],
    isQtyError: [],
    isAgeError: [],
    isValueError: [],
    isDescriptionError: [],
    isItemTypError: [],
    isActionError: [],
    isDetailsError: [],
    itemConditionError: [],
    isAmountSoughtError:[],
    isSeekCompensation : [],
    count: 0,
    noticeItemList:[],
    submitNoticeStep2ViewModel:{},
    NoticeNumber:"",
});

const actionsMap = {
    [UPDATE_SUBMITNOTICE_DETAILS]: (state, action) => {
      return state.set('submitNoticeDetails', action.data);
    },
    [UPDATE_IS_NAME_ERROR]: (state, action) => {
      return state.set('isNameError', action.data);
    },
    [UPDATE_IS_QTY_ERROR]: (state, action) => {
      return state.set('isQtyError', action.data);
    },
    [UPDATE_IS_AGE_ERROR]: (state, action) => {
      return state.set('isAgeError', action.data);
    },
    [UPDATE_IS_DESCRIPTION_ERROR]: (state, action) => {
      return state.set('isDescriptionError', action.data);
    },
    [UPDATE_IS_ITEMTYPE_ERROR]: (state, action) => {
      return state.set('isItemTypError', action.data);
    },
    [UPDATE_IS_ACTION_ERROR]: (state, action) => {
      return state.set('isActionError', action.data);
    },
    [UPDATE_IS_DETAILS_ERROR]: (state, action) => {
      return state.set('isDetailsError', action.data);
    },
    [UPDATE_IS_VALUE_ERROR]: (state, action) => {
      return state.set('isValueError', action.data);
    },
    [UPDATE_ITEM_CONDITION_ERROR]: (state, action) => {
      return state.set('itemConditionError', action.data);
    },
    [UPDATE_COUNT]: (state, action) => {
      return state.set('count', action.data);
    },
    [UPDATE_NOTICE_ITEM_LIST]: (state, action) => {
      return state.set('noticeItemList', action.data);
    },
    [UPDATE_SUBMITNOTICESTEP2_VIEWMODEL]: (state, action) => {
      return state.set('submitNoticeStep2ViewModel', action.data);
    },
    [UPDATE_IS_AMOUNTSOUGHT_ERROR]: (state, action) => {
      return state.set('isAmountSoughtError', action.data);
    },
    [UPDATE_IS_SEEK_COMPENSATION]: (state, action) => {
      return state.set('isSeekCompensation', action.data);
    },
    [UPDATE_NOTICENUMBER]: (state, action) => {
      return state.set('NoticeNumber', action.data);
    },
};

export default function facilities(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}